import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { ListItemAddress } from '../../components/ListItemAddress';
import { ListItemPhoneNumber } from '../../components/ListItemPhoneNumber';
import { ListItemEmail } from '../../components/ListItemEmail';
import { ListItemOrgNo } from './ListItemOrgNo';
import { ListItemCompanyName } from './ListItemCompanyName';
import { License, LicenseModel } from '../../interfaces';
import { useMutation } from '@apollo/client/react';
import { UPDATE_NAME, UPDATE_ORGNUMBER, UPDATE_EMAIL, UPDATE_PHONE, UPDATE_ADDRESS, UPDATE_INVOICEREF } from './LicenseInfo.graphql';
import { ListItemWithEdit } from '../../components/ListItemWithEdit';
import { Receipt, Security, WorkspacePremium } from '@mui/icons-material';
import NewADFSButton from '../../administration/ADFSConfig/AddADFSConfigDialog';
import DeleteAdfs from '../../administration/ADFSConfig/DeleteAdfs';

interface ListProps {
  display: boolean;
  bksLicense: License;
  license: LicenseModel;
}

export function LicenseCard({ display, bksLicense, license }: ListProps) {
  const exec = (action, obj) => action({ variables: { input: { id: bksLicense.id, ...obj } } });
  const [updateName] = useMutation<any, any>(UPDATE_NAME);
  const [updateOrgNo] = useMutation<any, any>(UPDATE_ORGNUMBER);
  const [updateEmail] = useMutation<any, any>(UPDATE_EMAIL);
  const [updatePhone] = useMutation<any, any>(UPDATE_PHONE);
  const [updateAddress] = useMutation<any, any>(UPDATE_ADDRESS);
  const [updateInvoiceRef] = useMutation<any, any>(UPDATE_INVOICEREF);

  const doUpdateName = (companyName) => exec(updateName, { companyName });
  const doUpdateOrgNo = (orgNumber) => exec(updateOrgNo, { orgNumber });
  const doUpdateEmail = (email) => exec(updateEmail, { email });
  const doUpdatePhone = (phone) => exec(updatePhone, { phone });
  const doUpdateAddress = (address) => updateAddress({ variables: { input: address } });
  const doUpdateInvoiceRef = (invoiceRef) => exec(updateInvoiceRef, { invoiceRef });
  const isAdfsType = (customerType) => {
    return customerType.toLowerCase() === 'brukernavn/passord' ? false : true;
  };
  if (!display) return null;
  return (
    <List>
      <ListItemCompanyName companyName={bksLicense.companyName} update={doUpdateName} />
      <ListItemOrgNo orgNumber={bksLicense.orgNumber} update={doUpdateOrgNo} />
      <ListItemEmail email={bksLicense.email} update={doUpdateEmail} />
      <ListItemPhoneNumber phone={bksLicense.phone} update={doUpdatePhone} />
      <ListItemAddress address={bksLicense.address} update={doUpdateAddress} />
      <ListItemWithEdit
        title="Faktura referanse"
        label="Faktura referanse"
        icon={<Receipt />}
        value={license ? license.invoiceRef : ''}
        update={doUpdateInvoiceRef}
      />
      <ListItem>
        <ListItemIcon title="Kundetype">
          <Security />
        </ListItemIcon>
        {!isAdfsType(bksLicense.customerType) && <ListItemText sx={{ maxWidth: 'fit-content' }}>{bksLicense.customerType}</ListItemText>}
        <ListItemText sx={{ textDecoration: 'none' }}>
          <NewADFSButton licenseId={bksLicense && bksLicense.id} licenseScheme={license && license.adfsScheme} companyName={bksLicense?.companyName} />
        </ListItemText>
        {isAdfsType(bksLicense.customerType) && (
          <ListItemText
            sx={{
              display: 'flex' as 'flex',
              justifyContent: 'flex-end' as 'flex-end',
            }}>
            <DeleteAdfs licenseId={bksLicense && bksLicense.id} provider={license && license.adfsScheme} />
          </ListItemText>
        )}
      </ListItem>
      {license?.isGodkjentVaatromsbedrift === true && (
        <ListItem>
          <ListItemIcon>
            <WorkspacePremium />
          </ListItemIcon>
          <ListItemText>Godkjent våtromsbedrift</ListItemText>
        </ListItem>
      )}
    </List>
  );
}
